/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Chat_Browser_Frame_ProgressInputs */



/**
* | output |
* | --- |
* | "{current} / {total}" |
*
* @param {Chat_Browser_Frame_ProgressInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_browser_frame_progress = /** @type {((inputs: Chat_Browser_Frame_ProgressInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Browser_Frame_ProgressInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.current} / ${i?.total}`)
	return /** @type {LocalizedString} */ (`${i?.current} / ${i?.total}`)
});